import React from 'react'

import { type IconProps, defaultPropsV2 } from './IconProps'

export const ArrowRight = (props: IconProps) => {
  return (
    <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.7677 8.00001C19.7677 7.76851 19.6655 7.55899 19.4799 7.38278L12.4022 0.293322C12.1871 0.0834167 11.9785 0 11.7564 0C11.2976 0 10.9452 0.343043 10.9452 0.80281C10.9452 1.02493 11.015 1.24285 11.1725 1.39096L13.9613 4.2224L17.8879 7.83548L18.0819 7.3514L14.7965 7.16486H0.825761C0.343039 7.16486 0 7.51728 0 8.00001C0 8.48273 0.343039 8.83515 0.825761 8.83515H14.7965L18.0819 8.64862L17.8879 8.17391L13.9613 11.7776L11.1725 14.6091C11.0192 14.7529 10.9452 14.9751 10.9452 15.1972C10.9452 15.657 11.2976 16 11.7564 16C11.9785 16 12.1786 15.9166 12.3642 15.7446L19.4799 8.61723C19.6655 8.44102 19.7677 8.2315 19.7677 8.00001Z"
        fill={props.colour}
      />
    </svg>
  )
}
ArrowRight.defaultProps = defaultPropsV2
